import request from '@/utils/Request'
import axios, { AxiosError } from 'axios';

export type CheckLoginResponse = {
    logged_in: boolean
}

export async function checkLogin() {
    try {
        const result = (await request.get<CheckLoginResponse>(`/check-login`, {},
            {
                headers: {'X-Skip-401-Interceptor': 'true'}
            },
        ))
        return result.data.logged_in
    } catch (error) {
        if (axios.isAxiosError(error)) {
            if (error.response && error.response.status === 401) {
                // 未ログイン時は401エラーが返るので正常系として処理する
                return false;
            }
        }
        // その他のエラーの場合はエラーを再度スロー
        throw error;
    }
}
